import SignUpInput from "components/SignUpInput";
import { SectionTitle } from "pages/Main/SectionTitle";
import React from "react";
import { Trans } from "react-i18next";
import styled, { keyframes } from "styled-components/macro";
import { mediaMin } from "styles/media";
import OutroImageSrc from "./outro.png";

const FluidWrapper = styled.section`
  width: 100%;
  background-color: ${({ theme }) => theme.background};
  overflow: hidden;
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 180px 24px 100px;
`;

const SectionTitleWrapper = styled.div`
  margin-bottom: 48px;
`;

const FlowAnimationWrapper = styled.div`
  width: 100%;
  height: 400px;
  perspective: 1000px;
`;

const backgroundPositionFlowAnimation = keyframes`
  0% {
    background-position-y: 0;
  }
  100% {
    background-position-y: -8000px;
  }
`;

const OutroImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  transform: rotateX(50deg);
  position: relative;

  background: url("${OutroImageSrc}");
  background-size: cover;
  background-repeat: repeat-y;
  background-position-x: center;
  animation: ${backgroundPositionFlowAnimation} 120s infinite linear;

  &:before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      0deg,
      rgba(24, 24, 24, 0) 20%,
      rgba(24, 24, 24, 1) 100%
    );
  }
`;

const StyledSectionTitle = styled(SectionTitle)`
  font-size: 32px;

  ${mediaMin.xs`
    font-size: 44px;
  `}

  ${mediaMin.sm`
    font-size: 56px;
  `}

  ${mediaMin.md`
    font-size: 58px;
  `}

  ${mediaMin.lg`
    font-size: 64px;
  `}
`;

const Description = styled.p`
  margin: 24px 0;
  text-align: center;
  line-height: 1.4;
  font-size: 18px;

  ${mediaMin.xs`
    font-size: 20px;
  `};
`;

export function BottomSignUpSection() {
  return (
    <FluidWrapper>
      <Wrapper>
        <SectionTitleWrapper>
          <StyledSectionTitle color="white">
            <Trans i18nKey="main.productivitySection.mainCopy" />
          </StyledSectionTitle>
          <Description>
            <Trans i18nKey="main.productivitySection.subCopy" />
          </Description>
        </SectionTitleWrapper>
        <SignUpInput formId="main-bottom-sign-up-form" />
        <FlowAnimationWrapper>
          <OutroImageWrapper />
        </FlowAnimationWrapper>
      </Wrapper>
    </FluidWrapper>
  );
}
